import ArticleLayout from '@/components/feature/ArticleLayout';
import { categories } from '@/mocks/categories';

const faqItems = [
  {
    q: 'Quante categorie ci sono nell\u2019itaobuy spreadsheet?',
    a: 'L\u2019itaobuy spreadsheet include 14 categorie principali: Scarpe, Felpe/Maglioni, T-Shirt, Giacche, Pantaloni/Corti, Copricapo, Set Completi, Intimo, Jersey, Accessori, Borse, Cinture, Profumi e Altro. Ogni categoria \u00e8 regolarmente aggiornata.',
  },
  {
    q: 'Posso trovare prodotti di marca su itaobuy?',
    a: 'S\u00ec, l\u2019itaobuy products spreadsheet include prodotti di varie fasce di prezzo e stili, inclusi articoli ispirati ai marchi pi\u00f9 popolari. Le foto QC ti aiutano a valutare la qualit\u00e0 indipendentemente dal brand.',
  },
  {
    q: 'Come vengono selezionati i prodotti in ogni categoria?',
    a: 'I prodotti vengono selezionati in base a criteri di qualit\u00e0, popolarit\u00e0 e rapporto qualit\u00e0-prezzo. Ogni articolo \u00e8 verificato attraverso foto QC prima di essere aggiunto al database.',
  },
  {
    q: 'Le categorie vengono aggiornate regolarmente?',
    a: 'S\u00ec, l\u2019itaobuy sheet viene aggiornato periodicamente con nuovi prodotti in ogni categoria. Ti consigliamo di controllare regolarmente il database per scoprire le ultime aggiunte.',
  },
];

export default function CategorieArticle() {
  const firstHalf = categories.slice(0, 7);
  const secondHalf = categories.slice(7);

  return (
    <ArticleLayout
      breadcrumbLabel="Categorie Itaobuy Spreadsheet"
      badges={[
        { label: 'Categorie', variant: 'primary' },
        { label: 'Prodotti', variant: 'accent' },
      ]}
      title="Tutte le Categorie Itaobuy Sheet: La Guida Completa per Ogni Sezione del Database"
      updateDate="Luglio 2026"
      readTime="9 minuti"
      faqItems={faqItems}
      sidebarChildren={
        <div className="rounded-2xl overflow-hidden bg-primary-50 p-0">
          <img
            src="https://readdy.ai/api/search-image?query=Organized%20fashion%20items%20displayed%20by%20category%20in%20grid%20layout%20on%20clean%20surface%20soft%20natural%20lighting%20warm%20cream%20background%20editorial%20product%20photography%20minimal%20aesthetic%20neat%20arrangement%20shoes%20bags%20clothing%20accessories&width=400&height=350&seq=qc-sidebar-categorie-001&orientation=landscape"
            alt="Categorie Itaobuy Spreadsheet - Organizzazione prodotti"
            title="Categorie itaobuy spreadsheet"
            className="w-full h-auto object-cover"
          />
        </div>
      }
    >
      <p>
        L&apos;<strong>itaobuy spreadsheet</strong> &egrave; organizzato in 14 categorie principali, ognuna delle quali contiene decine di prodotti selezionati con foto QC e informazioni dettagliate. In questa guida esploreremo ogni <strong>categoria itaobuy</strong> nel dettaglio, per aiutarti a navigare il database in modo efficiente e trovare esattamente ci&ograve; che cerchi.
      </p>

      <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-10 mb-4">
        Panoramica delle Categorie Itaobuy
      </h2>
      <p>
        L&apos;<strong>itaobuy products list</strong> copre un&apos;ampia gamma di prodotti, dall&apos;abbigliamento agli accessori, dalle scarpe ai profumi. Ogni categoria &egrave; stata pensata per rispondere a esigenze specifiche e facilitare la ricerca. <a href="/" className="text-primary-600 hover:text-primary-700 underline font-medium">Visita la homepage</a> per un accesso rapido a tutte le categorie.
      </p>

      <div className="space-y-4 mt-4">
        {firstHalf.map((cat) => (
          <div key={cat.id} className="p-4 rounded-xl bg-background-100 flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
              <i className={`${cat.icon} text-lg`}></i>
            </div>
            <div>
              <h3 className="font-semibold text-foreground-900 text-sm">{cat.nameIt}</h3>
              <p className="text-xs text-foreground-500">Categoria {cat.name} - Prodotti selezionati e foto QC disponibili</p>
            </div>
            <a
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="ml-auto flex items-center gap-1 px-3 py-1.5 rounded-full bg-background-50 text-primary-600 text-xs font-medium hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Esplora <i className="ri-arrow-right-up-line text-xs"></i>
            </a>
          </div>
        ))}
      </div>

      <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-10 mb-4">
        Accessori e Altro: Le Categorie Complementari
      </h2>
      <p>
        Oltre all&apos;abbigliamento, l&apos;<strong>itaobuy sheet</strong> include una ricca selezione di accessori e prodotti complementari che completano il tuo stile:
      </p>

      <div className="space-y-4 mt-4">
        {secondHalf.map((cat) => (
          <div key={cat.id} className="p-4 rounded-xl bg-background-100 flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
              <i className={`${cat.icon} text-lg`}></i>
            </div>
            <div>
              <h3 className="font-semibold text-foreground-900 text-sm">{cat.nameIt}</h3>
              <p className="text-xs text-foreground-500">Categoria {cat.name} - Articoli verificati con controllo qualit&agrave;</p>
            </div>
            <a
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="ml-auto flex items-center gap-1 px-3 py-1.5 rounded-full bg-background-50 text-accent-600 text-xs font-medium hover:bg-accent-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Esplora <i className="ri-arrow-right-up-line text-xs"></i>
            </a>
          </div>
        ))}
      </div>

      <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-10 mb-4">
        Come Scegliere la Categoria Giusta per Te
      </h2>
      <p>
        Con 14 categorie a disposizione, pu&ograve; sembrare difficile orientarsi. Ecco alcuni consigli pratici per navigare al meglio l&apos;<strong>itaobuy spreadsheet italiano</strong>:
      </p>
      <ul className="list-disc list-inside space-y-2 pl-2">
        <li className="text-foreground-700"><strong>Parti dalle tue necessit&agrave;:</strong> Se cerchi scarpe, inizia dalla categoria Scarpe e poi esplora le sottocategorie.</li>
        <li className="text-foreground-700"><strong>Usa i filtri:</strong> All&apos;interno di ogni categoria puoi filtrare per prezzo, stile e popolarit&agrave;.</li>
        <li className="text-foreground-700"><strong>Confronta tra categorie:</strong> A volte prodotti simili si trovano in categorie diverse: esplora con curiosit&agrave;.</li>
        <li className="text-foreground-700"><strong>Controlla sempre le foto QC:</strong> Indipendentemente dalla categoria, le foto di controllo qualit&agrave; sono il tuo miglior alleato.</li>
      </ul>
      <p className="mt-4">
        Per approfondire la sicurezza negli acquisti, consulta la <a href="/itaobuy-spreadsheet-sicurezza" className="text-primary-600 hover:text-primary-700 underline font-medium">guida alla sicurezza itaobuy</a>. Se sei alle prime armi, la <a href="/itaobuy-spreadsheet-principianti" className="text-primary-600 hover:text-primary-700 underline font-medium">guida per principianti</a> ti aiuter&agrave; a muovere i primi passi.
      </p>

      <p className="mt-6">
        Ora che conosci ogni categoria nel dettaglio, sei pronto per esplorare il database. <a href="/" className="text-primary-600 hover:text-primary-700 underline font-medium">Torna alla homepage</a> e inizia subito la tua navigazione!
      </p>
    </ArticleLayout>
  );
}